import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { useSelector } from "react-redux";
import CourseOfferingDisplay from "./CourseOfferingDisplay";

const CourseModal = ({ onSubmit }) => {
  const { course: currentCourse } = useSelector((state) => state.courses);

  const courseDetails = {
    title: "Course Details",
    leftCol: [
      { title: "Course Id:", info: currentCourse.course_id },
      { title: "Course name:", info: currentCourse.course_name },
    ],
    rightCol: [
      {
        title: "Course Level:",
        info: currentCourse.course_level,
      },
      // {
      //   title: "Start Date:",
      //   info: <FormattedStartEndDate date={activity_date} />
      // },
      // {
      //   title: "End Date:",
      //   info: <FormattedStartEndDate date={activity_date} />
      // },
      // { title: "Location:", info: currentEvent.activity_venue },
    ],
    // fullCol: []
  };

  return (
    <Form onSubmit={onSubmit}>
      <CourseOfferingDisplay courseDetails={courseDetails} />
    </Form>
  );
};

export default CourseModal;
